export default __webpack_public_path__ + "static/media/Map_Lidar_Gray.8d40f08b.svg";